import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  button: {
    width: '20%',
  },
  paper: {
    padding: 20,
  },
  avatarIcon: {
    marginRight: 20,
  },
  webView: {
    background: theme.webView.background,
  },
}))

export default useStyles
